var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 3.75H8.625C5.79657 3.75 4.38236 3.75 3.50368 4.62868C2.625 5.50736 2.625 6.92157 2.625 9.75V10.5C2.625 13.3284 2.625 14.7427 3.50368 15.6213C4.38236 16.5 5.79657 16.5 8.625 16.5H9.375C12.2034 16.5 13.6177 16.5 14.4963 15.6213C15.375 14.7427 15.375 13.3284 15.375 10.5V9.75C15.375 6.92157 15.375 5.50736 14.4963 4.62868C13.6177 3.75 12.2034 3.75 9.375 3.75Z",
    stroke: "#98A1B0",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 5.625C8.25 6.24632 8.7537 6.75 9.375 6.75C9.9963 6.75 10.5 6.24632 10.5 5.625V3C10.5 2.17157 9.82845 1.5 9 1.5C8.17155 1.5 7.5 2.17157 7.5 3V3.75",
    stroke: "#98A1B0",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 13.125H9.375M5.625 10.125H12.375",
    stroke: "#98A1B0",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/note-icon.cb4f33649ecdef6525f370a53e575f0f.svg";
export { ForwardRef as ReactComponent };